import React from 'react';
import FormModal from '../../components/common/FormModal';

const CategoryOrderModal = ({ show, onHide, loading, data }) => {
  return (
    <FormModal show={show} onHide={onHide} title="Category Order List" size="lg">
      {loading ? (
        <div className="admin-crud-loader" style={{ minHeight: '200px' }}>
          <div className="admin-crud-spinner"></div>
        </div>
      ) : (
        <div className="admin-crud-table-wrapper">
          <table className="admin-crud-table">
            <thead>
              <tr>
                <th>Title</th>
                <th style={{ width: '120px' }}>Display Order</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((post) => (
                <tr key={post.id}>
                  <td>{post.title}</td>
                  <td>
                    <span className="admin-crud-badge admin-crud-badge-info">
                      {post.displayOrder}
                    </span>
                  </td>
                </tr>
              ))}
              {(!data || data.length === 0) && (
                <tr>
                  <td colSpan="2" className="admin-crud-empty-state">
                    <div className="admin-crud-empty-icon">📭</div>
                    <div className="admin-crud-empty-text">No posts found</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </FormModal>
  );
};

export default CategoryOrderModal;